import React from "react";
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer, Stack, TableHead, Checkbox, TablePagination,
  TableRow, Typography, TextField, Breadcrumbs, Link, Button, InputAdornment,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Tooltip from '@mui/material/Tooltip';
import {
  Edit as EditIcon,
  Save
} from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import { Delete as DeleteIcon } from '@mui/icons-material'

const TableComponent = ({
  FiltersJsx,
  columns,
  rows,
  CountryJsx,
  handleRowDoubleClick,
  handleSearchChange,
  handleChangePage,
  handleChangeRowsPerPage,
  handleClick,
  handleHomeClick,
  handleLocationclick,
  filteredRows,
  title,
  titleMaster,
  handleIconClick,
  isEditMode,
  setIsEditMode,
  selectedRows,
  setSelectedRows,
  onCellEdit,
  isLoading,

}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(17);
  const [selected, setSelected] = React.useState([]);
  // const [isEditMode, setIsEditMode] = React.useState(false);
  const location = useLocation();
  const permissions = location.state?.permissions || [];

  const isSelected = (index) => selectedRows.indexOf(index) !== -1;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleLocationNavigation = () => {
    handleLocationclick(permissions);
  };

  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

  const isCellEditable = (rowIndex, columnId, value) => {
    if (!isEditMode || !selectedRows.includes(rowIndex)) return false;

    // Check if it's not one of the base columns (first 5 columns)
    const isBaseColumn = ['RoomNo', 'RoombedName', 'RoomTypeName', 'RoomBedTypeName', 'RoomViewNAme'].includes(columnId);
    if (isBaseColumn) return false;

    // Check if column is a year column
    if (columnId.startsWith('year_')) return false;

    // For month columns, only allow editing if current value is A, M, or R
    // return ['A', 'M', 'R'].includes(value);
    // if (value === 'B') return false;
    if (['B', 'P', 'C'].includes(value)) return false;
    // if (!['R', 'A', 'M'].includes(value?.toUpperCase())) return false;
    return true;
  };

  const handleCellChange = (event, rowIndex, columnId, currentValue) => {
    const newValue = event.target.value.toUpperCase();

    if (newValue === '') {
      onCellEdit(rowIndex, columnId, '', currentValue);
      return;
    }
    if (['A', 'M', 'R'].includes(newValue)) {
      onCellEdit(rowIndex, columnId, newValue, currentValue);
    }
  };

  const getCellBackgroundColor = (value, originalValue) => {
    // Use originalValue if value is empty
    const effectiveValue = value || originalValue;
    if (!effectiveValue) return null;

    const upperValue = String(effectiveValue).toUpperCase();

    switch (upperValue) {
      case 'A':
        return '#00b300';
      case 'C':
        return '#c971bb';
      case 'B':
        return '#635bff';
      case 'M':
        return '#800000';
      case 'R':
        return '#47a1ba';
      case 'P':
      case 'P':
        return '#d17b49';
      default:
        return null;
    }
  };

  const renderCell = (rowIndex, columnId, value, originalValue) => {
    if (isCellEditable(rowIndex, columnId, value)) {
      const backgroundColor = getCellBackgroundColor(value, originalValue);
      return (
        <TextField
          value={value || ''}
          onChange={(e) => handleCellChange(e, rowIndex, columnId, originalValue)}
          size="small"
          inputProps={{
            style: {
              textAlign: 'center',
              padding: '0.1px',
              fontSize: '12px',
              backgroundColor: backgroundColor,
              color: backgroundColor ? '#ffffff' : 'inherit',
            },
            maxLength: 1
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
              },
              '&:hover fieldset': {
                borderColor: 'primary.main',
              },
              width: '30px',
              height: '25px'
            }
          }}
        />
      );
    }

    const backgroundColor = getCellBackgroundColor(value, originalValue);
    return (
      <div style={{
        backgroundColor,
        color: backgroundColor ? '#ffffff' : 'inherit',
        padding: '0px',
        fontWeight: backgroundColor ? 'bold' : 'normal',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {value || ''}
      </div>
    );
  };

  return (
    <Box
      sx={{
        maxWidth: "95vw",
        overflowX: "hidden",
        backgroundColor: "#f9f9f9",
        minHeight: "80vh",
      }}
    >
      <ToastContainer />
      <Box
        sx={{
          backgroundColor: "#ffffff",
          padding: "5px 22px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
          borderRadius: "12px",
          margin: "10px auto",
          maxWidth: "95%",
        }}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          separator="›"
          sx={{ fontSize: "16px" }}
        >
          <Link
            onClick={handleHomeClick}
            underline="hover"
            color="#635bff"
            sx={{ cursor: "pointer" }}
          >
            Home
          </Link>

          <Typography
            color="#635bff"
            onClick={handleLocationclick}
            sx={{ cursor: "pointer", fontWeight: "bold" }}
          >
            {title}
          </Typography>
          <Typography color="text.primary" sx={{ fontWeight: "bold" }}>
            {titleMaster}
          </Typography>
        </Breadcrumbs>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: "16px",
            minWidth: "300px",
          }}
        >
          {FiltersJsx ? FiltersJsx : null}
        </Box>
      </Box>

      <Paper
        sx={{
          width: "97%",
          overflow: "hidden",
          margin: "10px auto",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
          padding: "20px",
          position: "relative",
        }}
      >
        <TableContainer sx={{ maxHeight: 480 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow sx={{ "& > th": { padding: "2px" } }}>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    sx={{
                      backgroundColor: "#dddbff",
                      color: "#333",
                      fontWeight: "600",
                      padding: "4px 2px 6px 5px !important",
                      border: "0.5px solid #ddd",
                      borderBottom: "2px solid #ddd",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ borderBottom: "0.5px solid #ddd" }}
                    >
                      {column.label}
                    </Typography>
                    <TextField
                      size="small"
                      variant="outlined"
                      // placeholder={`Search ${column.label}`}
                      onChange={(e) =>
                        handleSearchChange(column.id, e.target.value)
                      }
                      sx={{
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#f9f9f9",
                          fontSize: "1.2rem",
                          height: "26px",
                        },
                      }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(index);
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      onDoubleClick={() => handleRowDoubleClick(row)}
                      selected={isItemSelected}

                      sx={{
                        "& > td": {
                          padding: "0px",
                          border: "0.5px solid #ddd",
                        },
                        "&:hover": {
                          backgroundColor: "#f1f1f1",
                          cursor: "pointer",
                        },
                        transition: "background-color 0.3s ease",
                      }}
                    >

                      {CountryJsx && <CountryJsx row={row} ind={index} />}
                      {CountryJsx
                        ? columns.slice(1).map((column) => {
                          const value = row[column.id];
                          const backgroundColor = getCellBackgroundColor(value);

                          return (
                            <Tooltip
                              title={value === 'B' ? `Resident Name: ${row.ResidentName || 'N/A'}\nBook No: ${row.BookNo || 'N/A'}` : ''}
                              arrow placement="top"
                            >
                              <TableCell
                                key={column.id}
                                align={column.align}
                                sx={{
                                  backgroundColor: backgroundColor,
                                  color: backgroundColor ? '#ffffff' : 'inherit',
                                  fontWeight: backgroundColor ? 'bold' : 'normal',
                                }}
                              >
                                {value}
                              </TableCell>
                            </Tooltip>
                          );
                        })

                        : columns.map((column) => {
                          const value = row[column.id];
                          const backgroundColor = getCellBackgroundColor(value);

                          return (
                            <Tooltip
                              title={value === 'B' ? `Resident Name: ${row.ResidentName ? row.ResidentName : 'N/A'}\nBook No: ${row.BookNo ? row.BookNo : 'N/A'}` : ''}
                              arrow placement="top"
                            >
                              <TableCell
                                key={column.id}
                                align={column.align}
                                sx={{
                                  backgroundColor: backgroundColor,
                                  color: backgroundColor ? '#ffffff' : 'inherit',
                                  fontWeight: backgroundColor ? 'bold' : 'normal',
                                  textAlign: 'center',
                                  verticalAlign: 'middle',
                                }}
                              >
                                {renderCell(index, column.id, value?.BedStatus || value || '', row[`${column.id}_original`])}
                              </TableCell>
                            </Tooltip>
                          );
                        })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        {isLoading && (
          <Box sx={{
            position: "absolute",
            top: 100,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            // zIndex: 1,
          }}>
            <CircularProgress sx={{ color: "#635bff" }} />
          </Box>
        )}

        <TablePagination
          rowsPerPageOptions={[100, 250, 500, 1000, 5000]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          handlePageChange={handlePageChange}
          onPageChange={(event, newPage) => handlePageChange(newPage)}
          onRowsPerPageChange={(event) => {
            const newRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(newRowsPerPage);
            setPage(0);
          }}
          sx={{
            backgroundColor: "#dddbff",
            borderTop: "1px solid #ddd",
            color: "#333",
            borderRadius: "0 0 12px 12px",
            "& .MuiToolbar-root": {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",

              flexWrap: "wrap",
            },
            "& .MuiTablePagination-displayedRows": {
              display: "none",
            },
            "& .MuiTablePagination-actions": {
              display: "none",
            },

            "& .MuiTablePagination-selectLabel": {
              marginBottom: 2,
            },
            "& .MuiTablePagination-select": {
              marginBottom: 0,
            },
          }}
          ActionsComponent={({ onPageChange }) => (
            <Stack
              // spacing={2}
              direction="row"
              alignItems="center"
              sx={{
                // flex: '1',
                justifyContent: "center",
                marginLeft: "16px",
              }}
            >
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={(event, newPage) => handlePageChange(newPage - 1)}
                showFirstButton
                showLastButton
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#635bff",
                    color: "#ffffff",
                  },
                }}
              />
            </Stack>
          )}
        />
      </Paper>
      {!isLoading && rows.length === 0 && (
        <Box sx={{
          width: "90%",
          margin: "20px auto",
          display: "flex",
          justifyContent: "center",
          color: "red",
        }}>
          No Record Found...
        </Box>
      )}
    </Box>
  );
};

export default TableComponent;